/*
 * Mobile menu drawer: hide the call link or a header button (Request
 * Consultation / second button) in the drawer while the same link is already
 * visible on screen — inline in the header, in the topbar or in the phone row
 * below the header.
 * Once that copy is off screen (e.g. the phone row scrolled away) or not
 * displayed at this breakpoint, the drawer shows it again. Without JS the
 * drawer simply shows everything.
 */
const drawer = document.getElementById('mobile-nav');

if (drawer && drawer.dataset.ctaVisibilityBound !== 'true') {
  drawer.dataset.ctaVisibilityBound = 'true';

  const onScreen = { primary: new Set(), secondary: new Set(), phone: new Set() };

  const update = () => {
    drawer.querySelectorAll('[data-drawer-cta]').forEach((link) => {
      const role = link.getAttribute('data-drawer-cta');
      link.hidden = Boolean(onScreen[role] && onScreen[role].size > 0);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const set = onScreen[entry.target.getAttribute('data-header-cta')];
      if (!set) return;
      if (entry.isIntersecting) {
        set.add(entry.target);
      } else {
        set.delete(entry.target);
      }
    });
    update();
  });

  document.querySelectorAll('[data-header-cta]').forEach((link) => observer.observe(link));
}
